/**
 * Demo-mode flag, two layers:
 *
 * - Build-time: set `VITE_DEMO=0` to build a demo-free app (the heavy demo
 *   graph is dynamic-imported, so disabling this also drops it from the bundle).
 * - Runtime: when the build includes demo support, a persisted switch picks the
 *   mounted gateway (demo ⇒ client-side data, off ⇒ BFF-backed). Flipping it
 *   reloads the app — the gateway and query cache are process-wide.
 *
 * This is the one tiny demo module production bootstrap may import directly —
 * the integration seam.
 */

/** Whether this build ships demo support at all. */
export const DEMO_BUILD = (import.meta.env.VITE_DEMO ?? '1') !== '0';

const RUNTIME_KEY = 'wand-demo-mode';

function runtimeEnabled(): boolean {
  try {
    return localStorage.getItem(RUNTIME_KEY) !== '0';
  } catch {
    return true;
  }
}

/** Whether demo mode is active for this app session (build flag + runtime switch). */
export const DEMO_ENABLED = DEMO_BUILD && runtimeEnabled();

/** Persist the runtime switch and reload so the whole app re-bootstraps on it. */
export function setDemoMode(on: boolean): void {
  try {
    localStorage.setItem(RUNTIME_KEY, on ? '1' : '0');
  } catch {
    /* ignore — the reload will just keep the current mode */
  }
  location.reload();
}
